const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString();

// 6 semillas concretas (§7)
const seeds = [
  {
    id: "c1",
    sourceUrl: "https://youtube.com/watch?v=n8n-facturas",
    platform: "YouTube",
    title: "Cómo automatizar facturas con n8n",
    summary:
      "Tutorial paso a paso para crear un flujo en n8n que lee facturas del email, extrae los datos y los vuelca en una hoja. 4 nodos clave.",
    mainTopic: "Automatización",
    usefulness: "automatización",
    tags: ["n8n", "automatización", "facturación"],
    status: "pendiente",
    analyzeStatus: "enriquecido",
    downloadStatus: "ninguna",
    meta: "14 min · canal AutomatizApp",
    createdAt: daysAgo(2),
  },
  {
    id: "c2",
    sourceUrl: "https://tiktok.com/@uidaily/video/1",
    platform: "TikTok",
    title: "Reel: inspiración UI dark dashboards",
    summary:
      "Recorrido por 5 dashboards en modo oscuro con buen uso de jerarquía y acentos.",
    mainTopic: "Diseño UI",
    usefulness: "inspiración UI",
    tags: ["inspiración-ui", "dark-mode", "dashboard"],
    status: "importante",
    analyzeStatus: "enriquecido",
    downloadStatus: "ninguna",
    meta: "0:48 · @uidaily",
    createdAt: daysAgo(3),
  },
  {
    id: "c3",
    sourceUrl: "https://x.com/dev/status/rag-barato",
    platform: "X",
    title: "Hilo: cómo montar un RAG barato",
    summary:
      "Stack mínimo para un RAG: embeddings locales + pgvector + reranking. Incluye costes reales.",
    mainTopic: "IA / RAG",
    usefulness: "formación",
    tags: ["IA", "RAG", "pgvector"],
    status: "inbox",
    analyzeStatus: "enriquecido",
    downloadStatus: "ninguna",
    meta: "hilo · 12 tuits",
    createdAt: daysAgo(1),
  },
  {
    id: "c4",
    sourceUrl: "https://blog.example.dev/fastapi-produccion",
    platform: "Web",
    title: "FastAPI en producción: checklist",
    summary:
      "Checklist de despliegue: workers, healthchecks, logging y límites.",
    mainTopic: "Backend",
    usefulness: "documentación",
    tags: ["fastapi", "backend", "deploy"],
    status: "aplicado",
    analyzeStatus: "enriquecido",
    downloadStatus: "disponible",
    meta: "blog · 9 min lectura",
    createdAt: daysAgo(9),
  },
  {
    id: "c5",
    sourceUrl: "https://youtube.com/watch?v=podcast-resumen",
    platform: "YouTube",
    title: "Idea de producto: resúmenes de podcasts",
    summary:
      "Oportunidades en herramientas de captura de conocimiento; el hueco tras el cierre de Pocket.",
    mainTopic: "Producto",
    usefulness: "idea de producto",
    tags: ["producto", "PKM"],
    status: "importante",
    analyzeStatus: "enriquecido",
    downloadStatus: "ninguna",
    meta: "22 min",
    createdAt: daysAgo(5),
  },
  {
    id: "c6",
    sourceUrl: "https://tiktok.com/@copysaas/video/2",
    platform: "TikTok",
    title: "Marketing: ganchos para landing SaaS",
    summary:
      "Patrones de copy para el hero de una landing SaaS. El gancho del 'dolor agudo' primero.",
    mainTopic: "Marketing",
    usefulness: "marketing",
    tags: ["marketing", "copy", "landing"],
    status: "inbox",
    analyzeStatus: "enriquecido",
    downloadStatus: "ninguna",
    meta: "1:10",
    createdAt: daysAgo(1),
  },
];

// ~22 más vía bucle (§7): [title, platform, status, analyzeStatus, mainTopic, usefulness, tags, meta, summary]
const extras = [
  ["Docker Compose para self-hosting sin dolor", "YouTube", "inbox", "enriquecido", "DevOps", "documentación", ["docker", "self-host"], "18 min · canal SelfHostES", "Guía de docker-compose con redes, volúmenes y healthchecks para montar tu stack self-hosted."],
  ["Postgres: índices que sí importan", "Web", "pendiente", "enriquecido", "Backend", "formación", ["postgres", "backend"], "blog · 7 min lectura", "Cuándo usar B-tree, GIN y BRIN. Ejemplos con EXPLAIN ANALYZE y errores comunes."],
  ["Claude API: tool use bien explicado", "YouTube", "inbox", "enriquecido", "IA / Agentes", "formación", ["IA", "claude", "agentes"], "26 min", "Cómo definir herramientas, manejar tool-calls encadenados y validar salidas del modelo."],
  ["Tailwind: sistema de tokens en 10 min", "YouTube", "aplicado", "enriquecido", "Diseño UI", "documentación", ["tailwind", "design-system"], "11 min", "Variables CSS + Tailwind para temas claro/oscuro sin duplicar clases."],
  ["Traefik vs Caddy para tu VPS", "Web", "inbox", "enriquecido", "DevOps", "comparativa", ["traefik", "self-host"], "blog · 6 min lectura", "Comparativa de proxies inversos: certificados, config declarativa y curva de aprendizaje."],
  ["Hilo: pricing para SaaS indie", "X", "importante", "enriquecido", "Negocio", "estrategia", ["saas", "pricing"], "hilo · 9 tuits", "Anclas de precio, plan gratuito como marketing y cuándo subir precios."],
  ["Reel: microinteracciones que enamoran", "TikTok", "inbox", "enriquecido", "Diseño UI", "inspiración UI", ["inspiración-ui", "motion"], "0:52 · @motiondesign", "5 microinteracciones sutiles: hover, focus y transiciones de estado."],
  ["pgvector: búsqueda semántica en Postgres", "YouTube", "pendiente", "enriquecido", "IA / RAG", "formación", ["IA", "RAG", "pgvector", "postgres"], "31 min", "Embeddings, índices HNSW y consultas híbridas con SQL puro."],
  ["BullMQ: colas de trabajo en Node", "Web", "inbox", "enriquecido", "Backend", "documentación", ["backend", "colas"], "docs · 12 min lectura", "Workers, reintentos exponenciales y paneles de monitorización para colas Redis."],
  ["Next.js App Router: patrones de datos", "YouTube", "aplicado", "enriquecido", "Frontend", "formación", ["nextjs", "frontend"], "24 min", "Server components, caché y mutaciones sin perder la cabeza."],
  ["Tipografía para interfaces densas", "Web", "inbox", "enriquecido", "Diseño UI", "formación", ["tipografía", "inspiración-ui"], "blog · 8 min lectura", "Escalas tipográficas, interletrado y jerarquía en dashboards con mucha información."],
  ["Hilo: entrevistas a usuarios sin sesgos", "X", "pendiente", "enriquecido", "Producto", "metodología", ["producto", "research"], "hilo · 14 tuits", "Preguntas abiertas, el test de la madre y cómo documentar hallazgos."],
  ["PKM: por qué abandonamos las notas", "YouTube", "inbox", "enriquecido", "Producto", "idea de producto", ["PKM", "producto"], "19 min", "La fricción de organizar mata los sistemas de notas. Capturar debe ser gratis."],
  ["Prompt engineering para resúmenes", "Web", "importante", "enriquecido", "IA / Agentes", "formación", ["IA", "prompts"], "blog · 10 min lectura", "Plantillas de prompt para resúmenes fieles: rol, formato y ejemplos few-shot."],
  ["Zustand: estado global sin boilerplate", "YouTube", "aplicado", "enriquecido", "Frontend", "documentación", ["frontend", "react"], "16 min", "Stores, selectores y persistencia en localStorage con middleware."],
  ["Reel: paletas cálidas para apps serenas", "TikTok", "archivado", "enriquecido", "Diseño UI", "inspiración UI", ["inspiración-ui", "color"], "0:39 · @palettes", "Neutros cálidos + un acento frío: cómo transmitir calma sin aburrir."],
  ["Accesibilidad: focus visible bien hecho", "Web", "pendiente", "enriquecido", "Frontend", "documentación", ["frontend", "a11y"], "blog · 5 min lectura", "Anillos de foco con contraste AA y navegación por teclado en modales."],
  ["Cómo escribir una newsletter técnica", "YouTube", "archivado", "enriquecido", "Marketing", "marketing", ["marketing", "contenido"], "21 min", "Estructura gancho-contexto-lección y frecuencia sostenible."],
  ["Redis como caché: patrones y trampas", "Web", "pendiente", "enriquecido", "Backend", "formación", ["backend", "redis"], "blog · 9 min lectura", "Cache-aside, TTLs sensatos e invalidación sin efectos raros."],
  ["Agentes de IA con LangGraph", "YouTube", "inbox", "enriqueciendo", "IA / Agentes", "", ["IA"], "34 min", ""],
  ["Reel: transiciones para shorts", "TikTok", "inbox", "enriqueciendo", "", "", [], "0:58", ""],
  ["MinIO y almacenamiento S3 self-hosted", "Web", "inbox", "error", "", "", [], "web", ""],
];

const extraItems = extras.map((e, i) => ({
  id: `e${i + 1}`,
  sourceUrl:
    e[1] === "YouTube"
      ? `https://youtube.com/watch?v=mock-${i + 1}`
      : e[1] === "TikTok"
        ? `https://tiktok.com/@creador/video/${i + 1}`
        : e[1] === "X"
          ? `https://x.com/dev/status/${1000 + i}`
          : `https://blog.example.dev/articulo-${i + 1}`,
  platform: e[1],
  title: e[0],
  summary: e[8],
  mainTopic: e[4],
  usefulness: e[5],
  tags: e[6],
  status: e[2],
  analyzeStatus: e[3],
  downloadStatus: "ninguna",
  meta: e[7],
  createdAt: daysAgo(i % 4 === 0 ? 1 : 3 + i),
}));

export const contentItems = [...seeds, ...extraItems];

export const TOTAL_SAVED_BASE = 186;
export const INITIAL_ITEM_COUNT = contentItems.length;

const STOPWORDS = new Set(["que", "para", "con", "los", "las", "una", "uno", "del", "por", "sobre", "como", "cómo", "guardé", "guardado", "último", "ultima", "última", "vídeo", "video", "búscame", "buscame", "busca", "quiero", "tengo", "hace", "días", "dias", "esta", "este", "más", "mas"]);

export const searchContent = (items, query) => {
  const words = (query || "")
    .toLowerCase()
    .split(/[^a-z0-9áéíóúüñ#-]+/i)
    .filter((w) => w.length > 2 && !STOPWORDS.has(w));
  if (!words.length) return [];
  return items
    .map((item) => {
      const hay = {
        title: item.title.toLowerCase(),
        tags: item.tags.join(" ").toLowerCase(),
        topic: (item.mainTopic || "").toLowerCase(),
        summary: (item.summary || "").toLowerCase(),
        platform: item.platform.toLowerCase(),
      };
      let score = 0;
      for (const w of words) {
        if (hay.title.includes(w)) score += 3;
        if (hay.tags.includes(w)) score += 3;
        if (hay.topic.includes(w)) score += 2;
        if (hay.summary.includes(w)) score += 1;
        if (hay.platform.includes(w)) score += 2;
      }
      return { item, score };
    })
    .filter((r) => r.score > 0)
    .sort((a, b) => b.score - a.score || new Date(b.item.createdAt) - new Date(a.item.createdAt))
    .map((r) => r.item);
};

export const searchKeyword = (query) => {
  const words = (query || "")
    .toLowerCase()
    .split(/[^a-z0-9áéíóúüñ#-]+/i)
    .filter((w) => w.length > 2 && !STOPWORDS.has(w));
  return words.sort((a, b) => b.length - a.length)[0] || "general";
};
